<template>
  <nav class="breadcrumbs">
    <ul
      class="breadcrumbs__wrapper"
      v-bind="schemaAttributes.ul">
      <li
        v-for="(item, i) in filteredItems"
        :key="item.href"
        class="breadcrumbs__item-wrapper"
        v-bind="schemaAttributes.li">
        <component
          :is="!isPlatformApp ? 'router-link' : 'p'"
          :to="item.href"
          class="breadcrumbs__item"
          v-bind="schemaAttributes.item"
          :title="item.title"
          @click.native.stop="emitActiveTagId(item.id)">
          <span v-bind="schemaAttributes.span">
            {{ item.title }}
          </span>
        </component>
        <meta
          v-if="enableSchema"
          itemprop="position"
          :content="i + 1">
      </li>
      <li
        v-if="items.length > 0"
        class="breadcrumbs__item-wrapper"
        v-bind="schemaAttributes.li">
        <span
          class="breadcrumbs__item breadcrumbs__item--disabled"
          v-bind="schemaAttributes.span">
          {{ items[items.length - 1].title }}
        </span>
        <meta
          v-if="enableSchema"
          itemprop="position"
          :content="items.length - 1">
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Breadcrumbs',

  props: {
    items: {
      type: Array,
      required: true,
    },
    enableSchema: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters(['isPlatformApp']),

    filteredItems() {
      return this.items
        .slice(0, -1)
        .filter((i) => i?.href !== this.$route.path);
    },

    schemaAttributes() {
      return this.enableSchema
        ? {
          ul: { itemscope: true, itemtype: 'https://schema.org/BreadcrumbList' },
          li: { itemprop: 'itemListElement', itemscope: true, itemtype: 'https://schema.org/ListItem' },
          item: { itemprop: 'item' },
          span: { itemprop: 'name' },
        }
        : {
          ul: {},
          li: {},
          item: {},
          span: {},
        };
    },
  },

  methods: {
    emitActiveTagId(tagId) {
      this.$emit('tagId', tagId ?? null);
    },
  },
};
</script>

<style lang="scss" scoped>
  .breadcrumbs {
    &__wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 5px;
    }

    &__item-wrapper:not(:first-of-type) {
      .breadcrumbs__item::before {
        content: '';
        width: 10px;
        height: 8px;
        display: inline-block;
        background: url(/images/icons/arrow-left.svg) no-repeat 0 1px;
        background-size: 12px;
        margin-right: 4px;
        transform: rotate(180deg);
      }
    }

    &__item {
      font-size: $text-11px;
      line-height: 18px;
      color: $color--basic-white;
      font-weight: 500;
      display: block;
      transition: color .15s ease-out;

      &:hover {
        color: $color--basic-light-gray;
      }

      &--disabled {
        font-weight: 300;
        color: $color--basic-light-gray;
      }
    }
  }
</style>
